export default {"src":"/_next/static/media/google-pay-white.e3b45716.svg","height":26,"width":63,"blurWidth":0,"blurHeight":0};